import request from '@/config/axios'

/** 直播运行配置（对齐 PHP 直播设置字段；密钥仅脱敏展示） */
export interface LiveConfigVO {
  enabled?: boolean
  provider?: string
  sdkAppId?: number
  imSdkAppId?: number
  hasSdkAppKey?: boolean
  hasImSecretKey?: boolean
  sdkAppKeyMasked?: string
  bizId?: string
  hasPushAuthKey?: boolean
  hasAuthKey?: boolean
  pushAuthKeyMasked?: string
  hasApiAuthKey?: boolean
  hasCallbackKey?: boolean
  apiAuthKeyMasked?: string
  pushDomain?: string
  playDomain?: string
  appName?: string
  expireSeconds?: number
  recordTemplateId?: number
  giftAnchorShareRate?: number
  giftCoinConvertPercent?: number
  runtimeLocalConfigPath?: string
  hasTrtcCam?: boolean
  trtcSecretIdMasked?: string
  trtcRegion?: string
  trtcLocalConfigPath?: string
}

export interface LiveRuntimeConfigSaveReqVO {
  enabled: boolean
  sdkAppId?: number
  sdkAppKey?: string
  bizId?: string
  pushDomain: string
  playDomain: string
  pushAuthKey?: string
  apiAuthKey?: string
  appName?: string
  expireSeconds?: number
  giftCoinConvertPercent: number
}

export interface LiveTrtcConfigSaveReqVO {
  secretId: string
  secretKey: string
  region?: string
}

export const get = () => request.get({ url: '/live/config/get' })

export const updateRuntime = (data: LiveRuntimeConfigSaveReqVO) =>
  request.put({ url: '/live/config/runtime', data })

export const updateTrtc = (data: LiveTrtcConfigSaveReqVO) =>
  request.put({ url: '/live/config/trtc', data })
